<template>
  <div>
    <filter-component />
    <table-component />
  </div>
</template>

<script>
  import FilterComponent from '@mailer/components/messages/messages-table-filter';
  import TableComponent from '@mailer/components/messages/messages-table';

  export default {
    components: {
      FilterComponent,
      TableComponent
    }
  };
</script>
